import { createMiddleware } from '@tanstack/react-start'

/**
 * Global server-function middleware: traces and logs every call, and maps a
 * thrown `HttpError` onto the real HTTP status (see `./rpc-telemetry`).
 *
 * The body is imported dynamically because this file is in the client graph
 * via `src/start.ts`, and `rpc-telemetry` pulls in the pino logger. A dynamic
 * `import()` inside `.server()` is what TanStack Start strips from the client.
 *
 * Registered in `src/start.ts` as `functionMiddleware`.
 */
export const httpErrorMiddleware = createMiddleware({ type: 'function' }).server(
  async ({ next, serverFnMeta }) => {
    const { runServerFn } = await import('./rpc-telemetry')
    return runServerFn(serverFnMeta, next)
  },
)
